import { ImageItem } from "./ImageItem";
import { TypeKeys } from "./TypeKeys";

export class SignItem extends ImageItem {
  constructor() {
    super(TypeKeys.SignItem);
  }

  public signatureGuid: string = null;
  public signatureCacheGuid: string = null;

  public clearImageInformation(): void {
    super.clearImageInformation();
    this.signatureGuid = null;
    this.signatureCacheGuid = null;
  }
 
  protected createCloneInstance(): SignItem {
    return new SignItem();
  }

  protected applyMembers(clone: SignItem): void {
    super.applyMembers(clone);
    clone.signatureGuid = this.cloneValue(this.signatureGuid);
    clone.signatureCacheGuid = this.cloneValue(this.signatureCacheGuid);
  }
}
